import React, { useRef, useEffect, useState } from 'react';

import VideoModal from 'react-scale/components/pages/document/video-modal';
import showModal from 'react-scale/components/tailwind/Modal/showModal';

const VideoOverlay = () => {
  const modal = showModal();
  const modalVideoRef = useRef(null)

  const [videoURL, setVideoURL] = useState('');

  useEffect(() => {
    const {search} = window.location;
    const params = new URLSearchParams(search);
    const foo = params.get('overlay');

    setVideoURL(foo);
    
    if (window.location.href.indexOf("overlay") !== -1 && videoURL !== '') {
      modal.toggle();
    }
  }, [videoURL]);

  return (
    <div className="w-full text-center transition-transform duration-200 ease-in-out group">
      <VideoModal
        ref={modalVideoRef}
        url={`https://scaleai.wistia.com/medias/${videoURL}`}
        {...modal}
      />
    </div>
  );
};

export default VideoOverlay;